import { EntityId } from "@reduxjs/toolkit";
import { useState } from "react";
import { DossierExportsOverviewDialog } from "../caseExports/DossierExportsOverviewDialog";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, Tooltip } from "@mui/material";

export interface DossierExportButtonProps {
    dossierId: EntityId;
    buttonText?: string;
    enabled: boolean;
}

export function DossierExportButton(props: DossierExportButtonProps) {
    const [showExportsForDossier, setShowExportsForDossier] = useState(false);

    return (
        <>
            <Tooltip title="Show available exports for this dossier">
                <Button
                    sx={{ minWidth: "auto" }}
                    startIcon={<FileDownloadIcon />}
                    onClick={(event) => {
                        event.stopPropagation(); // Prevents parent onRowClick
                        setShowExportsForDossier(true);
                    }}
                    disabled={!props.enabled}
                >
                    {props.buttonText}
                </Button>
            </Tooltip>

            {showExportsForDossier && (
                <DossierExportsOverviewDialog
                    dossierId={props.dossierId}
                    closeDialog={() => setShowExportsForDossier(false)}
                />
            )}
        </>
    );
}
